module.exports = __webpack_public_path__ + "imgs/PuffCo.85c2e8e15809bc1b6ddd95269c4be724.png";